<template>
<Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
        <template> {{$t('add')}}</template>
        
    </template>
    <template slot="body">
        <Dropdown
            :id="'supplier_id'"
            class="m2"
            :options="supplierTV"
            :selected="supplierTV.find((b) => b.value == supplier_id)"
            :placeholder="$dft.capHead($t('supplier'))"
            deselect
            box
            @selectedChange="(e) => onDropdownChange('supplier_id', e)"
          ></Dropdown>

         <Dropdown
            :id="'supply_order_type'"
            class="m2"
            :options="supplyOrderTypeTV"
            :selected="supplyOrderTypeTV.find((b) => b.value == supply_order_type)"
            :placeholder="$t('supply_order_type')"
            deselect
            box
            @selectedChange="(e) => onDropdownChange('supply_order_type', e)"
          ></Dropdown>
    </template>
    <template slot="options">
      
        <button  class="dt-button s7" @click="onCancelClick">{{$t('cancel')}}</button>
        <button class="dt-button s7 v1" @click="onOKClicked">{{$t('ok')}}</button>
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";


import ModalContainer from "@dtplugins/modal/modal-container";


import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";
import { SupplierOrdersService } from '../../services/supplier.order.service';
import { createTV } from '../../../../models/text-value.model';




export default {
  props: {
    supplyOrderTypeTV: {
      type: Array,
      default:[]
    }
  },
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,

   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    //DistributionStatementService
    const tvResData = await SupplierOrdersService.newSupplierOrderForm();
    this.modalData = tvResData.data;
    console.log("::::::::::::",tvResData)
  },
  data: function () {
    return {
        modalData:{},
        supplier_id:null,
        supply_order_type:null
    };
  },
   mixins: [],

  computed: {

    supplierTV:function(){
        return createTV(this.modalData?.suppliers,'supplier_name','supplier_id')
    }

  },
  methods: { 
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

    onDropdownChange:function(name ,e){ 
        console.log(e)
        this[name] =e.value
    },


    onOKClicked:function(){
        this.$emit("onAdd",{supplier_id:this.supplier_id,supply_order_type:this.supply_order_type})
    }
    
  
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {

}
</style>